enum ErrorKey {
  //    ############################
  //   ###  client-side errors  ###
  //  ############################
  // Force numbering to start at 1, otherwise !!ErrorKeys.NoServerResponse = false
  NoServerResponse = 1, // backend did not provide a response, likely network issue
  UnknownBackendError, // backend sent an error key that's not in this enum
  GenericSave, // generic issue while trying to save something
  WrongAddress, // generic issue with an address
  NoCart, // no shopping cart was set, but one was expected
  NoSuchCartItem, // a shopping cart item was expected, but none was found
  UnitNotFound, // product added to cart with unknown unit
  LoginStatusCheckFailed, // unspecified issue checking authentication on access to protected route
  AlreadyPending, // the same action was already requested but not yet completed
  NoMegacardSelected,

  //     ##############################################
  //    ###  generic action-based fallback errors  ###
  //   ##############################################
  CartMergeAction, // unable to merge carts
  CartFetchAction, // unable to fetch cart
  CartSaveAction, // unable to save cart
  ShopMinOrderValueFetchAction,
  AddressListFetchAction, // unable to fetch addresses
  AddressSaveAction, // unable to save address
  AddressDeleteAction, // unable to delete address
  CategoriesFetchAction, // unable to fetch categories
  LanguageChangeAction, // unable to change language
  UserFetchAction, // unable to fetch user
  UserPageSizeSaveAction, // unable to save user page size
  UserCreateAction, // unable to create user
  UserUpdateAction, // unable to update user
  ProductListFetchAction, // unable to fetch products
  ProductDetailFetchAction, // unable to fetch product detail
  KeycloakInitializationAction, // unable to initialise keycloak
  CmsFetchAction, // unable to fetch content from CMS

  //     #######################################################
  //    ###  server-side errors, suffixed with "Exception"  ###
  //   #######################################################
  ConflictException,
  DisabledUserException,
  DuplicateEmailException,
  EmptyOrderException,
  ForbiddenShopException,
  ForbiddenTenantException,
  ForbiddenUserException,
  IllegalShopException,
  InvalidEssentialFilterException,
  InvalidInputException,
  InvalidShoppingCartAmountException,
  MinSaleQuantityViolationException,
  MissingTenantSettingsException,
  NoCategoryForProductException,
  NoInvoiceAPIException,
  NonEssentialProductException,
  NoSuchAddressException,
  NoSuchCartItemException,
  NoSuchCategoryException,
  NoSuchOrderException,
  NoSuchProductException,
  NoSuchShoppingCartException,
  NoSuchUnitException,
  NoSuchUserException,
  IndexNotFoundException,
  ElasticsearchException,
  NoNodeAvailableException,
  AccessControlException,
  TenantAccessDeniedException,
  ShopAccessDeniedException,
  CanNotDeleteDefaultAddress,
  DeliveryNotSupportedException,
  MissingOrderAddressException,
  DeliverySlotExpiryException,
  ExternalException,
  NoSuchMegacardException,
  MegacardImportException,
  MegacardConflictException,
  OrderHistoryPageFetchException,
  OrderHistoryDetailFetchException,
  UpdateDefaultAddress,
  AgeRestrictionException,
  AddCouponException,
  RemoveCouponException,
  CmsNotFoundException,
  NoSuchShoppingListException,
  CmsFormSubmissionException,
  MissingAddressException,
  ErpStatusException,
  ErpConnectException,
}

export default ErrorKey;
